// @ts-strict-ignore
import { ComponentType, MouseEventHandler } from 'react';
import styled from 'styled-components';

import { Box } from 'components/Box';
import { LegacyButton as Button } from 'components/Button/LegacyButton';
import { Icon } from 'components/Icon';
import { BodyMicro } from 'components/Text/BodyMicro';
import { colors, mediaRetina, transition } from 'theme';
import { isDefined } from 'utils/functional';

type Props = {
  title?: string;
  text: string;
  onClick: MouseEventHandler;
  active?: boolean;
  'aria-label'?: string;
  outline?: boolean;
  component?: ComponentType<{
    borderRadius: number | string;
    p: string;
    height: string | number;
    'aria-label': string;
    title: string;
    onClick: MouseEventHandler;
  }>;
};

export const Pill = styled(
  ({
    title,
    text,
    onClick,
    'aria-label': ariaLabel,
    active,
    outline,
    component,
    ...props
  }: Props) => {
    const Component = component || Button;
    return (
      <Component
        borderRadius={20}
        p="2px 12px"
        height={32}
        aria-label={ariaLabel || title}
        title={title}
        onClick={onClick}
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...props}
      >
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          width="100%"
        >
          <BodyMicro
            tag="span"
            textOverflow="ellipsis"
            overflow="hidden"
            whiteSpace="nowrap"
          >
            {text}
          </BodyMicro>
          {(!isDefined(active) || active) && (
            <Box flex="0 0 auto" ml="8px">
              <Icon initialColorName="todo-replace-me" name="close" size={8} />
            </Box>
          )}
        </Box>
      </Component>
    );
  }
)`
  max-width: 100%;
  display: flex;
  align-items: center;
  ${(props) => `
    background: ${
      // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line no-nested-ternary
      props.active
        ? colors.waterBlue
        : props.outline
        ? 'transparent'
        : colors.offWhite
    };
    color: ${
      // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line no-nested-ternary
      props.active
        ? 'white'
        : props.outline
        ? colors.battleshipGrey
        : colors.waterBlue
    };
    ${
      props.outline && !props.active
        ? `
      box-shadow: 0 0 0 1px ${colors.aluminum} inset;
      &:hover {
        box-shadow: 0 0 0 1px transparent inset;
      }
      ${mediaRetina} {
        box-shadow: 0 0 0 1px ${colors.aluminum} inset;
        &:hover {
          box-shadow: 0 0 0 1px transparent inset;
        }
      }
    `
        : ''
    }
    &:hover {
      background: ${props.active ? colors.niceBlue : colors.waterBlue};
    }
  `}
  transition: all ${transition};
  &:hover {
    color: white;
  }
`;
